// FixMe
// tslint:disable
import * as FluxUtils from 'flux/utils';

import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { ArticleItem } from './ArticleStore';

import core = egr.wcf.core;

export interface ArticleProperties {
    properties: Map<string, Array<core.prop.Property>> | null;
    classes: Array<core.prop.PropertyClass> | null;
}

interface ActiveChoiceListState {
    property: core.prop.Property | null;
    choiceList: Array<core.prop.PropertyValue> | null;
}

export enum EAIWSStoreSyncState {
    SYNCING = 1 << 0,
    NEEDS_SYNC = 1 << 1,
}

export namespace EAIWSStoreSyncState {
    export function syncInProgress(state: EAIWSStoreSyncState): boolean {
        return (state & EAIWSStoreSyncState.SYNCING) === EAIWSStoreSyncState.SYNCING;
    }

    export function shouldSync(state: EAIWSStoreSyncState): boolean {
        return (state & EAIWSStoreSyncState.NEEDS_SYNC) === EAIWSStoreSyncState.NEEDS_SYNC && !syncInProgress(state);
    }
}

interface EAIWSStoreState {
    syncState: EAIWSStoreSyncState;
    propertyEditorSetup: ArticleProperties;
    propertyEditorActive: ActiveChoiceListState;
    articleItem: ArticleItem | null;
}

class EAIWSStoreClass extends FluxUtils.ReduceStore<EAIWSStoreState, any> {
    public getInitialState(): EAIWSStoreState {
        return {
            syncState: 0 as EAIWSStoreSyncState,
            propertyEditorSetup: {properties: null, classes: null},
            propertyEditorActive: {property: null, choiceList: null},
            articleItem: null
        };
    }

    public reduce(state: EAIWSStoreState, action: DispatcherBaseAction): EAIWSStoreState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        switch (action.actionType) {
            case ActionConstants.PE_SETUP:
                return jQuery.extend({}, state, {
                    propertyEditorSetup: action.value
                });
            case ActionConstants.UPDATE_SELECTION:
                return jQuery.extend({}, state, {
                    propertyEditorActive: {property: null, choiceList: null}
                });
            case ActionConstants.PE_SETACTIVE:
                return jQuery.extend({}, state, {
                    propertyEditorActive: action.value
                });
            case ActionConstants.PE_INVALIDE:
                return jQuery.extend({}, state, {
                    articleImage: null,
                    syncState: state.syncState | EAIWSStoreSyncState.NEEDS_SYNC
                });
            case ActionConstants.PE_START_SYNC:
                return jQuery.extend({}, state, {
                    syncState: (state.syncState | EAIWSStoreSyncState.SYNCING) & ~EAIWSStoreSyncState.NEEDS_SYNC
                });
            case ActionConstants.PE_STOP_SYNC:
                return jQuery.extend({}, state, {
                    syncState: state.syncState & ~EAIWSStoreSyncState.SYNCING
                });
            case ActionConstants.PE_ARTICLE_ITEM:
                return jQuery.extend({}, state, {
                    articleItem: action.value
                });
            case ActionConstants.RESET_PROJECT_RELATED_SETTINGS:
                return jQuery.extend({}, this.getInitialState());
            default:
                return state;
        }
    }
}

export let EAIWSStore: EAIWSStoreClass = new EAIWSStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/EAIWSStore.ts